<script>
  // Add your JavaScript code here
</script>

<style>
    /* Add your CSS styles here */
    header {
        background-color: #333;
        color: white;
        padding: 1rem;
        font-size: 1.5rem;
    }
</style>

<header>
    <!-- Add your HTML code here -->
    Treevs
</header>
